import { Component, OnInit, ChangeDetectorRef, ViewChild } from '@angular/core';
import {
  ModalController,
  NavController,
  IonSearchbar,
  ViewWillEnter,
} from '@ionic/angular';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';

import { ProductService } from '../services/product.service';
import { ClientService } from '../services/client.service';
import { Product } from '../models';
import { List } from 'immutable';
import { debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';

import { Platform } from '@ionic/angular';
export interface IProductSelectEvent {
  index: number;
  product: Product;
}

export interface IProductFormModalCallBackData {
  product: Product;
  action: string;
}
@Component({
  selector: 'app-products',
  templateUrl: './products.page.html',
  styleUrls: ['./products.page.scss'],
})
export class ProductsPage implements OnInit, ViewWillEnter {
  public isLoading: boolean = true;

  public products: List<Product>;

  public errorOccurredWhileLoadingProducts: boolean = false;
  public searchField: UntypedFormControl;
  public isSearching: boolean = false;
  public errorOccurredWhileSearching: boolean;
  public searchedList: List<Product>;
  public searchForm: UntypedFormGroup;
  public isMobile: boolean = false;
  constructor(
    private productService: ProductService,
    private changeDetectorRef: ChangeDetectorRef,
    private clientService: ClientService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private platform: Platform
  ) {
    this.isLoading = true;
    this.products = List([]);

    this.searchField = new UntypedFormControl();
    this.searchForm = this.formBuilder.group({
      searchField: this.searchField,
    });
  }

  public ionViewWillEnter() {
    this.loadProducts();
    this.initSearchObserver();
  }

  public ngOnInit() {
    this.loadProducts();
    this.initSearchObserver();
    this.platform.ready().then(() => {
      if (
        this.platform.is('mobile') ||
        this.platform.is('android') ||
        this.platform.is('iphone') ||
        this.platform.is('mobileweb')
      ) {
        this.isMobile = true;
      }
    });
  }
  public newProduct() {
    this.router.navigate(['/products/0']);
  }
  public onTapToReload() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingProducts = false;
    this.loadProducts();
  }

  public loadProducts() {
    this.isLoading = true;
    this.errorOccurredWhileLoadingProducts = false;
    this.products = List([]);

    this.productService.loadProducts().subscribe({
      next: (products) => {
        this.isLoading = false;
        this.products = products;
        this.changeDetectorRef.markForCheck();
      },
      error: (err) => {
        this.isLoading = false;
        this.errorOccurredWhileLoadingProducts = true;
        this.changeDetectorRef.markForCheck();
      },
    });
  }

  public editProduct(event: IProductSelectEvent) {
    this.router.navigate(['/products/', event.product.id]);
  }

  public initSearchObserver() {
    this.searchField.valueChanges.pipe(debounceTime(400)).subscribe(
      (term: string) => {
        let searchableTerm = term.trim();

        if (this.clientService.isProductTermSearchable(term)) {
          this.isSearching = true;
          this.errorOccurredWhileSearching = false;
          let searchableKeys = [
            'size',
            'category',
            'brand',
            'supplier',
            'retail', // price
            'name',
          ];

          let compositeSearchableKeys = ['category', 'brand', 'supplier'];

          let searchedArray = [...this.products.toJS()];

          searchedArray = searchedArray.filter((value) => {
            let matchesTerm = false;
            searchableKeys.forEach((key) => {
              if (!matchesTerm) {
                let valueToMatch = value[key];

                if (compositeSearchableKeys.indexOf(key) > -1 && !!value[key]) {
                  valueToMatch = value[key]['name'];
                }

                if (key == 'retail') {
                  valueToMatch = '' + valueToMatch.toFixed(2);
                }

                if (
                  !!valueToMatch &&
                  (('' + valueToMatch)
                    .toLowerCase()
                    .includes(searchableTerm.toLowerCase()) ||
                    valueToMatch == searchableTerm)
                ) {
                  matchesTerm = true;
                  return;
                }
              }
            });
            return matchesTerm;
          });

          this.searchedList = List([]).push(...searchedArray);
        } else {
          this.isSearching = false;
        }
        this.changeDetectorRef.markForCheck();
      },
      (error) => {
        this.isSearching = false;
        this.errorOccurredWhileSearching = true;
      }
    );
  }
}
